import { captureSentryError, useGqtyClient } from '@vrplatform/data';
import { createUUID } from '@vrplatform/components-legacy';
import {
  showLoadingNotification,
  updateErrorNotification,
  updateSuccessNotification,
} from '@vrplatform/theme';
import type { StatementInput } from '@vrplatform/ui-common';
import { useState } from 'react';
import { getOwnerStatementPdf } from '../pdf';
import type { FileTransferDisposition } from '../../../../utils';

export function useStatementPdfExport() {
  const [loading, setLoading] = useState(false);
  const hasura = useGqtyClient();

  const exportPdf = async (
    args: StatementInput,
    disposition: FileTransferDisposition
  ) => {
    setLoading(true);
    const id = createUUID();

    try {
      showLoadingNotification({ id });
      await getOwnerStatementPdf({
        hasura,
        input: args,
        opts: {
          disposition,
        },
      });
      updateSuccessNotification({
        id,
        title: 'PDF Export',
        message:
          disposition === 'openInNewTab'
            ? 'PDF opened in a new tab.'
            : 'PDF downloaded successfully.',
      });
    } catch (error: any) {
      console.error(error);
      captureSentryError(error);
      updateErrorNotification({
        id,
        title: 'PDF Generation Error',
        message: error?.message || 'Error while generating PDF',
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    openPdf: (args: StatementInput) => exportPdf(args, 'openInNewTab'),
    downloadPdf: (args: StatementInput) => exportPdf(args, 'download'),
  };
}
